import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=04ee577b&scoped=true&"
var script = {}
import style0 from "./VFooter.vue?vue&type=style&index=0&id=04ee577b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ee577b",
  null
  
)

export default component.exports